module.exports = __webpack_public_path__ + "static/media/palm-icon.0728a65c.png";